<template>
  <v-card :elevation="$vuetify.breakpoint.xsOnly ? 0 : ''" v-if="site">
    <v-card-title>
      {{ $t('sites.quote.title') }}
    </v-card-title>
    <v-card-text>
      <v-alert type="info" text dense class="mb-4">
        {{ $t('sites.quote.help') }}
      </v-alert>
      <v-textarea
        v-model="site.quote"
        :clearable="!$isOnlyTenantBasic"
        :label="$t('sites.quote.label')"
        :placeholder="$t('sites.quote.placeholder')"
        :readonly="$isOnlyTenantBasic"
        auto-grow
        autocomplete="off"
        dense
        hide-details
        outlined
        rows="20"
      >
        <template v-slot:prepend>
          <v-icon>mdi mdi-file-document-outline</v-icon>
        </template>
      </v-textarea>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SiteQuote",
  props: ['site'],
}
</script>
